const ORDOCLIC_APP_EPRESCRIPTION_URL = process.env.REACT_APP_ORDOCLIC_APP_EPRESCRIPTION_URL
const ORDOCLIC_ICONNECT_URL = 'https://auth.staging.ordoclic.fr'

export { ORDOCLIC_APP_EPRESCRIPTION_URL, ORDOCLIC_ICONNECT_URL }
